exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.latest-traject-table tr:first-child td {\n  text-align: left;\n  border-top: none;\n}\ntable.latest-traject-table td {\n  padding-left: 0px !important;\n}\n.action_icon {\n  color: #5A4587 !important;\n}\n.action_icon:hover {\n  color: #9b89c3 !important;\n}\n.card-block {\n  position: relative;\n}\n", ""]);

// exports
